const primaryNav = document.querySelector('.lom-menu');
const navToggle = document.querySelector('.nav__button--hamburger');
const navLinks = primaryNav.querySelectorAll('a');

// mobile / tablet view
navToggle.addEventListener('click', () => {
	const visibility = primaryNav.getAttribute('data-visible');

	if (visibility === 'false') {
		primaryNav.setAttribute('data-visible', true);
		navToggle.setAttribute('aria-expanded', true);
	} else {
		primaryNav.setAttribute('data-visible', false);
		navToggle.setAttribute('aria-expanded', false);
	}
});

// sub menu dropdown
document.addEventListener('click', e => {
	const isDropDownBtn = e.target.matches('.lom-menu__link--arrow');
	if (!isDropDownBtn && e.target.closest('.lom-menu__link--arrow') != null) return;

	let currentDropdown;
	if (isDropDownBtn) {
		currentDropdown = e.target.closest('.lom-menu__item--dropdown');
		currentDropdown.classList.toggle('active');
	}

	document.querySelectorAll('.lom-menu__item--dropdown, .active').forEach(dropdown => {
		if (dropdown === currentDropdown) {
			return
		} else {
			dropdown.classList.remove('active');
		}
	});
});

// style the link for page you're on differently
navLinks.forEach(link => {
	if(link.href == window.location.href) {
		link.setAttribute('aria-current', 'page');
	}
});

const toolbarEl = document.querySelector('.toolbar');

if (toolbarEl) {
	document.querySelector('.lom-nav').classList.add('lom-gin-toolbar');
}